module.exports = __webpack_public_path__ + "media/images/webpage/hotels/743/plan1-2-fd3169afcd87099c249179bf0a4866a2.webp";